import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, map, merge, of, Subscription } from 'rxjs';

/** Network Status Service */
@Injectable({
	providedIn: 'root',
})
export class NetworkStatusService {
	networkStatus: any;
	networkStatus$: Subscription = Subscription.EMPTY;

	/** show Offline Ui behavior subject */
	checkConnection = new BehaviorSubject(false);
	/** show Offline Ui observable */
	checkConnection$ = this.checkConnection.asObservable();
	/**
	 * Constructor
	 */
	constructor() {}

	/**
	 * Get Network Status
	 *
	 * @returns networkStatus
	 */
	getNetworkStatus() {
		this.networkStatus = navigator.onLine;
		this.networkStatus$ = merge(of(null), fromEvent(window, 'online'), fromEvent(window, 'offline'))
			.pipe(map(() => navigator.onLine))
			.subscribe((status) => {
				this.networkStatus = status;
				this.checkConnection.next(status);
			});
		return this.networkStatus;
	}
}
